import { Tooltip, withStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: variables.white,
    color: variables.black50,
    boxShadow: `0 10px 20px 0 ${variables.boxShadow}`,
    fontSize: 12,
  },
  arrow: {
    color: variables.white,
  },
}))(Tooltip);
